// extracted by mini-css-extract-plugin
export default {"readingTime":"ReadingTime_readingTime__67KxH","readingTimeIcon":"ReadingTime_readingTimeIcon__Xmxp+"};